import { AddPhotoAlternate, Close, Edit } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Dialog,
  Grow,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import axiosInstance from "../../../config/axios";

const ImageGallery = ({
  isDelete,
  response,
  setResponse,
  variantId,
  setProductId,
  productId,
}) => {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [uploadImages, setUploadImages] = useState(null);
  const [updateImage, setUpdateImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [images, setImages] = useState([]);

  const [imageId, setImageId] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };

  const GetAllProduct = (id) => {
    axiosInstance
      .get(
        `api/admin/product-overview-image-admin-api/?product_id=${variantId}`,
      )
      .then((res) => {
        setImages(res?.data?.data);
      });
  };

  useEffect(() => {
    productId && GetAllProduct();
  }, [productId]);

  useEffect(() => {
    setImage(images?.[0]?.overview_image);

    setImageId(images?.[0]?.id);
  }, [images]);

  const handleDelete = (id) => {
    axiosInstance
      .delete(`api/admin/product-overview-image-admin-api/`, {
        data: {
          product: productId,
          overview_image_id: id,
        },
      })
      .then((res) => {
        toast.success(res.data.message);
        GetAllProduct();
        // setResponse(!response)
      });
  };

  const handleAdd = () => {
    setIsLoading(true);
    const foundImage = uploadImages;
    const reqbody = new FormData();
    if (foundImage) {
      for (const file of foundImage) {
        reqbody.append("overview_image", file);
      }
      reqbody.append("product", productId);
    }

    axiosInstance
      .post(`api/admin/product-overview-image-admin-api/`, reqbody)
      .then((res) => {
        GetAllProduct();
        setUploadImages(null);
        toast.success(res.data.message);

        setIsLoading(false);
      })

      .catch(() => {
        setIsLoading(false);
      });
  };
  const handleUpdate = () => {
    const reqbody = new FormData();
    reqbody.append("overview_image", updateImage);
    reqbody.append("product", productId);
    reqbody.append("overview_image_id", imageId);
    axiosInstance
      .patch(`api/admin/product-overview-image-admin-api/`, reqbody)
      .then((res) => {
        toast.success(res.data.message);
        GetAllProduct();

        setUpdateImage(null);

        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    uploadImages && handleAdd();
  }, [uploadImages]);

  useEffect(() => {
    updateImage && imageId && handleUpdate();
  }, [updateImage]);

  return (
    <>
      {image ? (
        <img
          src={image}
          alt=""
          className="w-6 h-6 cursor-pointer"
          onClick={() => {
            setOpen(true);
            setProductId(variantId);
          }}
        />
      ) : (
        <img
          src="https://pub-16f3de4d2c4841169d66d16992f9f0d3.r2.dev/assets/Inventory/NoImage.png"
          alt=""
          className="w-6 h-6 cursor-pointer"
          onClick={() => {
            setOpen(true);
            setProductId(variantId);
          }}
        />
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Grow}
        PaperProps={{ className: "!p-2" }}
      >
        {/* <div className="relative flex">
          <Close
            className="!absolute !right-0 !text-red-300 hover:!text-red-500 !cursor-pointer !top-0"
            onClick={handleClose}
          />
        </div> */}
        <span className="relative   h-[50vh]    flex items-center  justify-center flex-col  ">
          {variantId && image && (
            <IconButton
              size="small"
              component="label"
              className="!bg-blue-500 !absolute !right-0 !bottom-0 !text-white"
            >
              <Edit />
              <input
                type="file"
                hidden
                onChange={(event) => setUpdateImage(event.target.files[0])}
              />
            </IconButton>
          )}
          <img
            src={
              image
                ? image
                : "https://pub-16f3de4d2c4841169d66d16992f9f0d3.r2.dev/assets/Inventory/NoImage.png"
            }
            alt=""
            className="  w-[50vw] h-full  object-contain"
          />
        </span>

        <div className="flex gap-2 pt-2 overflow-x-auto">
          {images?.map((i) => {
            return (
              <span className="relative w-16  overflow-x-auto">
                {isDelete && (
                  <Close
                    fontSize="small"
                    className="!absolute !right-0 !text-red-500 !cursor-pointer !top-0"
                    onClick={() => handleDelete(i.id, i.variant_id)}
                  />
                )}
                <img
                  src={i?.overview_image}
                  alt=""
                  className={`w-16 h-16 p-px border-2 ${imageId === i?.id ? "border-red-600" : "border-blue-400"}  rounded cursor-pointer hover:border-blue-500`}
                  onClick={() => {
                    setImage(i?.overview_image);
                    setImageId(i?.id);
                  }}
                />
              </span>
            );
          })}
          {variantId && (
            <Button
              component="label"
              className="!border !h-16 !w-16 !border-dashed border-spacing-5"
            >
              {isLoading ? (
                <>
                  <CircularProgress size={35} />
                </>
              ) : (
                <>
                  <input
                    type="file"
                    hidden
                    multiple
                    onChange={(event) => {
                      setUploadImages(event.target.files);
                    }}
                  />
                  <AddPhotoAlternate />
                </>
              )}
            </Button>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default ImageGallery;
